// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1Vve3","load2":"Spinner_load2__MgRZO"};